<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input placeholder="请输入内容" v-model="filters.newsname" style="width: 400px;">
            <el-select v-model="filters.selectType" slot="prepend" style="width: 120px;" >
              <el-option label="标题" value="1"></el-option>
              <el-option label="第一作者" value="2"></el-option>
              <el-option label="创建者"  v-if="roleId !=12 " value="3"></el-option>
              <el-option label="修改者"  v-if="roleId !=12 " value="4"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item  v-if="roleId !=12 ">
          <el-select v-model="filters.dateType" placeholder="请选择时间" >
            <el-option label="创建时间"  value="1"></el-option>
            <el-option label="修改时间"  value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="filters.beginDate"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          <el-date-picker
            v-model="filters.endDate"
            type="date"
            placeholder="截至日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item v-if="roleId !=12 ">
          <el-select v-model="filters.state"  style="width: 120px;" >
            <el-option label="全部" value="2"></el-option>
            <el-option label="未审核" value="0"></el-option>
            <el-option label="已审核"   value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" v-on:click="getInitList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd" >新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleDeleteBatdch" v-if=" roleId !=12" >批量删除</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="compileNews" highlight-current-row v-loading="listLoading" @selection-change="handleSelectionChange" style="width: 100%;" border>
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column prop="titleName" label="标题" width="560" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="authorship" label="第一作者" width="140" >
      </el-table-column>
      <el-table-column prop="creator" label="创建者" min-width="120" >
      </el-table-column>
      <el-table-column prop="state" label="状态" min-width="90" :formatter="formatpstate" >
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="180" >
      </el-table-column>
      <el-table-column prop="motifyor" label="修改者" min-width="120" >
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" min-width="180" >
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="publisNew(scope.$index, scope.row)" v-if=" roleId !=12 && roleId !=9 && scope.row.state ==0">审核</el-button>
          <el-button size="small" @click="cancelPublish(scope.$index, scope.row)" v-if=" roleId !=12 && roleId !=9 && scope.row.state ==1">取消审核</el-button>
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :current-page="currentPage">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog :title="addFormTtile" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" ref="addForm" :rules="addFormRules" >
        <el-form-item label="标题" prop="newsTitle" label-width="100px">
          <el-input v-model.trim="addForm.newsTitle" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="第一作者" prop="author" label-width="100px">
          <el-input v-model.trim="addForm.author" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit(0)" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  /*import { getNewsListPage,getConsultList,getDictProject,getDictNewsType,getDictSubject, addNewsInfo, delNewsInfo, validateNewsTitle, editNewsInfo } from '../../api/api';*/

  import { getCompileNewsPage,addCompileNews,delCompileNews,vftelTitleName,editCompileNews,batchDelCms,updateState} from '../../api/api';
  export default {
    data() {
      var validateNITitle = (rule, value, callback) => {
        if(value!=''){
          if (this.addForm.id == 0 || (this.addForm.id != 0 && this.addForm.oldName != this.addForm.newsTitle)) {
            const formData = new FormData();
            formData.append('name', value);
            vftelTitleName(formData).then(function (response) {
              if (!response.data.status) {
                callback(new Error('标题重复'));
              } else {
                callback();
              }
            })
          }else {
            callback();
          }
        }else{
          callback(new Error('请填写标题名称'));
        }
      };
      return {
        roleId:'',
        userName:'',
        filters: {
          newsname: '',
          selectType:'1',
          dateType:'1',
          beginDate:'',
          state:'2',
          endDate:''
        },
        multipleSelection: [],//全选数组
        compileNews: [],
        total: 0,
        pageSize:10,
        page: 1,
        addFormTtile:'',
        currentPage:1,
        listLoading: false,
        sels: [],//列表选中列
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          newsTitle: [
            { required: true, validator: validateNITitle,trigger: 'blur' }
          ],
          author: [
            { required: true, message: '请填写第一作者', trigger: 'blur' }
          ],
        },
        //新增界面数据
        addForm: {
          id:'',
          oldName:'',
          newsTitle:'',
          author:''
        }
      }
    },
    methods: {
      //性别显示转换
      formatpstate: (row)=> {
        return row.state == 0 ? '未审核' : '已审核' ;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getInitList();
      },

      handleSelectionChange(val) {//多选
        this.multipleSelection = val;
      },

      //发布资讯
      publisNew(index, row){
        this.$confirm('确认审核该资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 1);
          updateState(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getInitList()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      //取消发布资讯
      cancelPublish(index, row){
        this.$confirm('确认取消审核该资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 0);
          updateState(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getInitList()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      //获取编译资讯列表
      getInitList() {
        const formData = new FormData();
        formData.append('pageNum', this.currentPage);
        formData.append('pageSize', this.pageSize);
        formData.append('titleName', this.filters.newsname);
        formData.append('selectType', this.filters.selectType);
        formData.append('dateType', this.filters.dateType);
        formData.append('startDate',(! this.filters.beginDate ||  this.filters.beginDate == '') ? '' : util.formatDate.format(new Date( this.filters.beginDate), 'yyyy-MM-dd'));
        formData.append('endDate',(! this.filters.endDate ||  this.filters.endDate == '') ? '' : util.formatDate.format(new Date( this.filters.endDate), 'yyyy-MM-dd'));
        formData.append('state', this.filters.state);
        /*formData.append('consultId', this.filters.consultId);
        formData.append('publishState', this.filters.pubstate);*/

        this.listLoading = true;
        getCompileNewsPage(formData).then((res) => {
          this.total = res.data.data.total;
          this.compileNews = res.data.data.list;
          this.listLoading = false;
        });
      },

      //显示编辑界面
      handleEdit(index, row) {

        if(this.userName != row.creator && this.roleId ==12){
          this.$message({
            type: 'warning',
            message: '兼职编辑没有编辑他人资讯权限！'
          });
          return;
        }

        this.addFormTtile="修改";
        this.addFormVisible = true;

        this.addForm.id=row.id;
        this.addForm.oldName=row.titleName;
        this.addForm.newsTitle=row.titleName;
        this.addForm.author=row.authorship;
      },

      handleDel(index, row) {//删除产品
        if(this.userName != row.creator && this.roleId ==12){
          this.$message({
            type: 'warning',
            message: '兼职编辑没有删除他人资讯权限！'
          });
          return;
        }
        this.$confirm('确认要删除该资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 2);
          delCompileNews(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getInitList()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },


      handleDeleteBatdch() {//批量删除
        this.$confirm('此操作将永久删除选中项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var _this = this;
          const formData = new FormData();
          var po="";
          for (var index in  this.multipleSelection){
            po+=this.multipleSelection[index].id+","
          }
          if(po.length>1){
            po=po. substring(0,po.length-1)
          }else{
            _this.$message({
              type: 'warning',
              message: '请选择删除'
            });
            return false;
          }
          formData.append('ids', po);
          batchDelCms(formData).then(function (response) {
            var data = response.data
            if (data.status == 200) {
              _this.$message({
                type: 'success',
                message: data.msg
              });
              _this.getInitList()
            } else {
              _this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //显示新增界面
      handleAdd() {
        this.addFormTtile="新增";
        this.addFormVisible = true;
        this.addForm.newsTitle='';
        this.addForm.author='';
      },
      //新增
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {

              this.addLoading = true;
              const formData = new FormData();
              formData.append('newsTitle', this.addForm.newsTitle);
              formData.append('author', this.addForm.author);

              if(this.addForm.id !=null && this.addForm.id !=""){ //修改
                formData.append('id', this.addForm.id);
                editCompileNews(formData).then((res) => {
                  this.addLoading = false;
                  if(res.data.status == 200){
                    this.$notify({
                      title: '成功',
                      message: '修改成功',
                      type: 'success'
                    });
                    this.$refs['addForm'].resetFields();
                    this.addFormVisible = false;
                    this.getInitList();
                  }else{
                    this.$notify({
                      title: '失败',
                      message: '修改失败',
                      type: 'fail'
                    });
                  }
                });
              }else{
                addCompileNews(formData).then((res) => {  //添加
                  this.addLoading = false;
                  if(res.data.status == 200){
                    this.$notify({
                      title: '成功',
                      message: '添加成功',
                      type: 'success'
                    });
                    this.$refs['addForm'].resetFields();
                    this.addFormVisible = false;
                    this.getInitList();
                  }else{
                    this.$notify({
                      title: '失败',
                      message: '添加失败',
                      type: 'fail'
                    });
                  }
                });
              }
            });
          }
        });
      },
      selsChange: function (sels) {
        this.sels = sels;
      },
    },
    mounted() {
      this.roleId=JSON.parse(sessionStorage.getItem(process.env.VUE_APP_APPKEY+"userInfo")).roleId;
      this.userName = JSON.parse(sessionStorage.getItem(process.env.VUE_APP_APPKEY+"userInfo")).username;
      this.getInitList();
    }
  }
</script>

<style scoped>
</style>
